import React, { FC, useCallback } from 'react'

import { Header, Loader, ErrorHandler } from 'components'
import { Page, PageContent, makeTraceDetails } from 'common'
import { logBridgeError, sendSelectContent } from 'common/helpers'
import { useScreenFinishLoadTac } from 'common/hooks/useScreenFinishLoadTac'
import { Routes } from 'common/constants'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAppContext } from 'contexts/app-context/hooks/useAppContext'
import { isEmpty } from 'lodash'
import { Button } from 'common/styles/layouts'

import { Text } from '@interco/inter-ui/components/Text'
import IcClose from '@interco/icons/core/action-navigation/ic_close'

import { MainContent, IconExit } from './styles'

export const UnavailableReport: FC = () => {
  const { privacyCenterContent, isAppLoading, isAppError, isAppActive, userSelectedEntity } =
    useAppContext()

  const navigate = useNavigate()

  const location = useLocation()

  const closeHandler = useCallback(async () => {
    try {
      await sendSelectContent({
        flow: 'unavailable_report',
        step: 'unavailable_report',
        screen_name: Routes.UNAVAILABLE_REPORT,
        element_name: 'closeUnavailableReport',
        element_type: 'button',
        parent_name: 'UnavailableReport',
        scenario: JSON.stringify({
          screen: Routes.UNAVAILABLE_REPORT,
          product: userSelectedEntity,
          ref_type: 'button',
          content_action: 'touch',
        }),
      })
    } catch (error: unknown) {
      logBridgeError('send unavailable report close tic', error)
    }

    navigate(location.state.goTo ?? -1)
  }, [location.state, navigate, userSelectedEntity])

  useScreenFinishLoadTac({
    name: 'UnavailableReport',
    entity: userSelectedEntity,
    action: 'UnavailableReport',
    screen: Routes.UNAVAILABLE_REPORT,
    shouldSend: true,
    logLabel: 'send unavailable report tac',
  })

  if (isAppLoading) return <Loader />

  const content = privacyCenterContent?.components.showReportErrorFeedback?.content

  const isActive = privacyCenterContent?.components?.yourPersonalData

  const isErrorOrInactive = isAppError || isEmpty(content) || !isActive || !isAppActive

  if (isErrorOrInactive) {
    const traceDetails = makeTraceDetails(!!isActive, content)

    return <ErrorHandler traceDetails={traceDetails} componentName={UnavailableReport.name} />
  }

  const { title, details, email, confirmButton } = content

  return (
    <Page>
      <Header title="" goToPath={Routes.REPORTS_HISTORY} />
      <PageContent>
        <MainContent>
          <IconExit>
            <IcClose width={32} height={32} color="#161616" />
          </IconExit>
          <Text variant="headline-h1" semiBold>
            {title}
          </Text>
          <Text variant="body-3">
            {details}
            <strong>{email}</strong>
          </Text>
        </MainContent>
        <Button style={{ marginBottom: '1rem' }} variant="primary" onClick={closeHandler}>
          {confirmButton}
        </Button>
      </PageContent>
    </Page>
  )
}
